
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { PackageItem } from '@/features/shipment/types';
import { getDimensions, getPrice } from '@/features/common/helpers';

@Component
export default class PackageSummaryQueryString extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) packages!: PackageItem[];

  private getPrice: (val: number, roundTo: number) => string = getPrice;

  private getDimensions: (item: PackageItem, addUnits: boolean) => string = getDimensions;

  private getMobilePackageInfo = (item: PackageItem): string => {
    const values = [
      `${item.weight} ${item.weightUnits}`,
      `${this.getDimensions(item, false)} ${item.dimUnits}`,
      item.insurance,
      item.isAdditionalHandling?.toString(),
    ];

    return values.map((i) => i || '-').join(', ');
  }
}
